import axios from 'axios'

const baseUrl = 'api/concept'

export function getConceptPatentFilingYears(conceptPks, numYears) {
    const request = {
        conceptPks,
        numYears,
    }

    return axios.post(`${baseUrl}/patent/filing_years`, request)
}

export function getEntitySummaryForConcepts(conceptPks) {
    return axios.post(`${baseUrl}/entity/summary`, { conceptPks })
}
